import { route, string } from "react-router-typesafe-routes";

export const authRoutes = route({
  path: "auth",
  searchParams: { returnTo: string().default("/"), linkToAccount: string() },
  children: {
    root: route({ path: "" }),
    phone: route({
      path: "phone",
      children: {
        verify: route({ path: "verify" }),
      },
    }),
    email: route({
      path: "email",
      children: {
        verify: route({ path: "verify" }),
      },
    }),
    callback: route({
      children: {
        sso: route({ path: "callback/:type" }),
      },
    }),
  },
});
